module.exports = __webpack_public_path__ + "static/media/road_img.f35af3dd.svg";